export const AngelRightSIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.89999 17.1998C9.29999 17.1998 8.89999 16.7998 8.89999 16.1998C8.89999 15.8998 8.99999 15.6998 9.19999 15.4998L12.7 11.9998L9.19999 8.4998C8.79999 8.0998 8.79999 7.4998 9.19999 7.0998C9.59999 6.6998 10.2 6.6998 10.6 7.0998L14.8 11.2998C15.2 11.6998 15.2 12.2998 14.8 12.6998L10.6 16.8998C10.4 17.0998 10.1 17.1998 9.89999 17.1998Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ModalCloseIcon = ({
  className = "",
  fillColor = "#999",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.87282 5.81289C6.58291 5.52298 6.10208 5.52298 5.81216 5.81289C5.52225 6.10281 5.52225 6.58364 5.81216 6.87355L10.9387 12.0001L5.81216 17.1266C5.52225 17.4165 5.52225 17.8973 5.81216 18.1873C6.10208 18.4772 6.58291 18.4772 6.87282 18.1873L11.9993 13.0607L17.1259 18.1873C17.4158 18.4772 17.8966 18.4772 18.1865 18.1873C18.4764 17.8973 18.4764 17.4165 18.1865 17.1266L13.06 12.0001L18.1865 6.87355C18.4764 6.58364 18.4764 6.10281 18.1865 5.81289C17.8966 5.52298 17.4158 5.52298 17.1259 5.81289L11.9993 10.9394L6.87282 5.81289Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CrownPremiumIcon = ({
  className = "",
  width = 14,
  height = 14,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_425_720442)">
        <rect
          width="14"
          height="14"
          fill="white"
          fillOpacity="0.01"
        />
        <g clipPath="url(#clip1_425_720442)">
          <path
            d="M12.7433 10.7734H1.52539V13.376H12.7433V10.7734Z"
            fill="#FFF0D4"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.37598 8.70658L7.01535 0.0625L12.7568 8.70658H1.37598Z"
            fill="#FFE0A9"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6742 10.1023L13.9867 2.46875L2.82227 9.8006L12.6742 10.1023Z"
            fill="#FFF0D4"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.33434 10.0626L0.0751953 2.4375L10.503 10.0626H1.33434Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_425_720442">
          <rect
            width="14"
            height="14"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_425_720442">
          <rect
            width="14"
            height="14"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CrownFreeIcon = ({ className = "", width = 14, height = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_425_720443)">
        <rect
          width="14"
          height="14"
          fill="white"
          fillOpacity="0.01"
        />
        <g clipPath="url(#clip1_425_720443)">
          <path
            d="M12.7433 10.7734H1.52539V13.376H12.7433V10.7734Z"
            fill="#CCCCCC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.37598 8.70658L7.01535 0.0625L12.7568 8.70658H1.37598Z"
            fill="url(#paint0_linear_425_720443)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6742 10.1023L13.9867 2.46875L2.82227 9.8006L12.6742 10.1023Z"
            fill="url(#paint1_linear_425_720443)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.33434 10.0626L0.0751953 2.4375L10.503 10.0626H1.33434Z"
            fill="#CCCCCC"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_425_720443"
          x1="7.06637"
          y1="0.0625"
          x2="7.06637"
          y2="8.70658"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9" />
          <stop
            offset="1"
            stopColor="#706D6D"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_425_720443"
          x1="8.40446"
          y1="2.46875"
          x2="8.40446"
          y2="10.1023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFDFDF" />
          <stop
            offset="1"
            stopColor="#949292"
          />
        </linearGradient>
        <clipPath id="clip0_425_720443">
          <rect
            width="14"
            height="14"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_425_720443">
          <rect
            width="14"
            height="14"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CrownIcon = ({
  className = "",
  fillColor = "#999",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8462 18.4614H2.61542V22.923H21.8462V18.4614Z"
        fill="#FA8C00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.35986 14.9229L12.0274 0.104492L21.8698 14.9229H2.35986Z"
        fill="#FF8C00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7276 17.3209L23.9775 4.23486L4.83856 16.8037L21.7276 17.3209Z"
        fill="#EDA500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.28798 17.2416L0.129456 4.16992L18.0057 17.2416H2.28798Z"
        fill="#FEC400"
      />
    </svg>
  );
};

export const SwatchBookIcon = ({
  className = "",
  fillColor = "#FA8C16",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83366 13.3307C5.66884 13.3307 5.50773 13.3796 5.37068 13.4712C5.23364 13.5627 5.12683 13.6929 5.06376 13.8452C5.00069 13.9974 4.98418 14.165 5.01634 14.3266C5.04849 14.4883 5.12786 14.6368 5.2444 14.7533C5.36095 14.8699 5.50943 14.9492 5.67108 14.9814C5.83273 15.0135 6.00029 14.997 6.15256 14.934C6.30483 14.8709 6.43498 14.7641 6.52655 14.627C6.61812 14.49 6.66699 14.3289 6.66699 14.1641C6.66699 13.943 6.5792 13.7311 6.42291 13.5748C6.26663 13.4185 6.05467 13.3307 5.83366 13.3307ZM15.8837 9.9974L16.9087 8.9724C17.3768 8.50365 17.6398 7.86823 17.6398 7.20573C17.6398 6.54323 17.3768 5.90781 16.9087 5.43906L14.5503 3.08906C14.0816 2.62089 13.4462 2.35793 12.7837 2.35793C12.1212 2.35793 11.4857 2.62089 11.017 3.08906L10.0003 4.11406C9.98724 3.45973 9.71808 2.83661 9.25065 2.37853C8.78322 1.92045 8.15479 1.66393 7.50033 1.66406H4.16699C3.50395 1.66406 2.86807 1.92745 2.39923 2.3963C1.93038 2.86514 1.66699 3.50102 1.66699 4.16406V15.8307C1.66699 16.4938 1.93038 17.1297 2.39923 17.5985C2.86807 18.0673 3.50395 18.3307 4.16699 18.3307H15.8337C16.4967 18.3307 17.1326 18.0673 17.6014 17.5985C18.0703 17.1297 18.3337 16.4938 18.3337 15.8307V12.4974C18.3338 11.8429 18.0773 11.2145 17.6192 10.7471C17.1611 10.2796 16.538 10.0105 15.8837 9.9974ZM8.33366 15.8307C8.33366 16.0517 8.24586 16.2637 8.08958 16.42C7.9333 16.5763 7.72134 16.6641 7.50033 16.6641H4.16699C3.94598 16.6641 3.73402 16.5763 3.57774 16.42C3.42146 16.2637 3.33366 16.0517 3.33366 15.8307V4.16406C3.33366 3.94305 3.42146 3.73109 3.57774 3.57481C3.73402 3.41853 3.94598 3.33073 4.16699 3.33073H7.50033C7.72134 3.33073 7.9333 3.41853 8.08958 3.57481C8.24586 3.73109 8.33366 3.94305 8.33366 4.16406V15.8307ZM10.0003 6.46406L12.2003 4.26406C12.3565 4.10885 12.5677 4.02174 12.7878 4.02174C13.008 4.02174 13.2192 4.10885 13.3753 4.26406L15.7337 6.66406C15.8889 6.8202 15.976 7.03141 15.976 7.25156C15.976 7.47172 15.8889 7.68293 15.7337 7.83906L13.3337 10.2391L10.0003 13.5307V6.46406ZM16.667 15.8307C16.667 16.0517 16.5792 16.2637 16.4229 16.42C16.2666 16.5763 16.0547 16.6641 15.8337 16.6641H9.85033C9.93581 16.4171 9.98357 16.1586 9.99199 15.8974L14.2253 11.6641H15.8337C16.0547 11.6641 16.2666 11.7519 16.4229 11.9081C16.5792 12.0644 16.667 12.2764 16.667 12.4974V15.8307Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const GlobeIcon = ({
  className = "",
  fillColor = "#FA8C16",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.842 7.19652C17.842 7.19652 17.842 7.19652 17.842 7.15486C17.2548 5.55171 16.1894 4.16759 14.7899 3.18974C13.3904 2.21189 11.7243 1.6875 10.017 1.6875C8.3097 1.6875 6.6436 2.21189 5.24408 3.18974C3.84456 4.16759 2.77916 5.55171 2.19199 7.15486C2.19199 7.15486 2.19199 7.15486 2.19199 7.19652C1.53626 9.0056 1.53626 10.9874 2.19199 12.7965C2.19199 12.7965 2.19199 12.7965 2.19199 12.8382C2.77916 14.4413 3.84456 15.8255 5.24408 16.8033C6.6436 17.7812 8.3097 18.3055 10.017 18.3055C11.7243 18.3055 13.3904 17.7812 14.7899 16.8033C16.1894 15.8255 17.2548 14.4413 17.842 12.8382C17.842 12.8382 17.842 12.8382 17.842 12.7965C18.4977 10.9874 18.4977 9.0056 17.842 7.19652ZM3.55033 11.6632C3.26135 10.5709 3.26135 9.42218 3.55033 8.32986H5.10033C4.96702 9.43697 4.96702 10.5561 5.10033 11.6632H3.55033ZM4.23366 13.3299H5.40033C5.59592 14.0731 5.8755 14.7916 6.23366 15.4715C5.41641 14.9148 4.73324 14.1832 4.23366 13.3299ZM5.40033 6.66319H4.23366C4.72605 5.81243 5.40049 5.08108 6.20866 4.52152C5.85912 5.20256 5.58794 5.92104 5.40033 6.66319ZM9.16699 16.4132C8.14346 15.6621 7.42462 14.5676 7.14199 13.3299H9.16699V16.4132ZM9.16699 11.6632H6.78366C6.62815 10.5575 6.62815 9.43553 6.78366 8.32986H9.16699V11.6632ZM9.16699 6.66319H7.14199C7.42462 5.4255 8.14346 4.33096 9.16699 3.57986V6.66319ZM15.767 6.66319H14.6003C14.4047 5.91999 14.1251 5.20147 13.767 4.52152C14.5842 5.07825 15.2674 5.80981 15.767 6.66319ZM10.8337 3.57986C11.8572 4.33096 12.576 5.4255 12.8587 6.66319H10.8337V3.57986ZM10.8337 16.4132V13.3299H12.8587C12.576 14.5676 11.8572 15.6621 10.8337 16.4132ZM13.217 11.6632H10.8337V8.32986H13.217C13.3725 9.43553 13.3725 10.5575 13.217 11.6632ZM13.792 15.4715C14.1501 14.7916 14.4297 14.0731 14.6253 13.3299H15.792C15.2924 14.1832 14.6092 14.9148 13.792 15.4715ZM16.4503 11.6632H14.9003C14.9681 11.1102 15.0015 10.5536 15.0003 9.99652C15.0012 9.43944 14.9678 8.88283 14.9003 8.32986H16.4503C16.7393 9.42218 16.7393 10.5709 16.4503 11.6632Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const SoundIcon = ({
  className = "",
  fillColor = "#FA8C16",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.375 17.2943C9.375 17.6359 9.65833 17.9193 10 17.9193C10.3417 17.9193 10.625 17.6359 10.625 17.2943V2.71094C10.625 2.36927 10.3417 2.08594 10 2.08594C9.65833 2.08594 9.375 2.36927 9.375 2.71094V17.2943ZM6.25 15.8359C5.90833 15.8359 5.625 15.5526 5.625 15.2109V4.79427C5.625 4.4526 5.90833 4.16927 6.25 4.16927C6.59167 4.16927 6.875 4.4526 6.875 4.79427V15.2109C6.875 15.5526 6.59167 15.8359 6.25 15.8359ZM2.5 13.7526C2.15833 13.7526 1.875 13.4693 1.875 13.1276V6.8776C1.875 6.53594 2.15833 6.2526 2.5 6.2526C2.84167 6.2526 3.125 6.53594 3.125 6.8776V13.1276C3.125 13.4693 2.84167 13.7526 2.5 13.7526ZM13.75 15.8359C13.4083 15.8359 13.125 15.5526 13.125 15.2109V4.79427C13.125 4.4526 13.4083 4.16927 13.75 4.16927C14.0917 4.16927 14.375 4.4526 14.375 4.79427V15.2109C14.375 15.5526 14.0917 15.8359 13.75 15.8359ZM16.875 13.1276C16.875 13.4693 17.1583 13.7526 17.5 13.7526C17.8417 13.7526 18.125 13.4693 18.125 13.1276V6.8776C18.125 6.53594 17.8417 6.2526 17.5 6.2526C17.1583 6.2526 16.875 6.53594 16.875 6.8776V13.1276Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CardAtmIcon = ({
  className = "",
  fillColor = "#FA8C16",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8337 3.75H4.16699C3.50395 3.75 2.86807 4.01339 2.39923 4.48223C1.93038 4.95107 1.66699 5.58696 1.66699 6.25V13.75C1.66699 14.413 1.93038 15.0489 2.39923 15.5178C2.86807 15.9866 3.50395 16.25 4.16699 16.25H15.8337C16.4967 16.25 17.1326 15.9866 17.6014 15.5178C18.0703 15.0489 18.3337 14.413 18.3337 13.75V6.25C18.3337 5.58696 18.0703 4.95107 17.6014 4.48223C17.1326 4.01339 16.4967 3.75 15.8337 3.75ZM16.667 13.75C16.667 13.971 16.5792 14.183 16.4229 14.3393C16.2666 14.4955 16.0547 14.5833 15.8337 14.5833H4.16699C3.94598 14.5833 3.73402 14.4955 3.57774 14.3393C3.42146 14.183 3.33366 13.971 3.33366 13.75V6.25C3.33366 6.02899 3.42146 5.81702 3.57774 5.66074C3.73402 5.50446 3.94598 5.41667 4.16699 5.41667H15.8337C16.0547 5.41667 16.2666 5.50446 16.4229 5.66074C16.5792 5.81702 16.667 6.02899 16.667 6.25V13.75ZM13.3337 8.75C12.8906 8.7531 12.4563 8.87389 12.0753 9.1C11.6957 8.87477 11.2633 8.75405 10.822 8.7501C10.3806 8.74615 9.94607 8.85912 9.56252 9.07752C9.17898 9.29592 8.86009 9.61197 8.63826 9.99355C8.41644 10.3751 8.29959 10.8086 8.29959 11.25C8.29959 11.6914 8.41644 12.1249 8.63826 12.5065C8.86009 12.888 9.17898 13.2041 9.56252 13.4225C9.94607 13.6409 10.3806 13.7538 10.822 13.7499C11.2633 13.746 11.6957 13.6252 12.0753 13.4C12.4068 13.5967 12.7793 13.714 13.1637 13.7429C13.5481 13.7718 13.9339 13.7114 14.2911 13.5664C14.6482 13.4215 14.967 13.1959 15.2226 12.9074C15.4781 12.6188 15.6635 12.275 15.7642 11.903C15.8648 11.5309 15.8781 11.1406 15.803 10.7625C15.7278 10.3845 15.5663 10.0289 15.331 9.72364C15.0956 9.41836 14.7929 9.17163 14.4464 9.00273C14.0999 8.83383 13.7191 8.74733 13.3337 8.75ZM10.9753 12.0833C10.9282 12.0874 10.8808 12.0874 10.8337 12.0833C10.6126 12.0833 10.4007 11.9955 10.2444 11.8393C10.0881 11.683 10.0003 11.471 10.0003 11.25C10.0003 11.029 10.0881 10.817 10.2444 10.6607C10.4007 10.5045 10.6126 10.4167 10.8337 10.4167C10.8808 10.4126 10.9282 10.4126 10.9753 10.4167C10.7868 10.9333 10.7868 11.5 10.9753 12.0167V12.0833ZM13.3337 12.0833C13.1688 12.0833 13.0077 12.0345 12.8707 11.9429C12.7336 11.8513 12.6268 11.7212 12.5638 11.5689C12.5007 11.4166 12.4842 11.2491 12.5163 11.0874C12.5485 10.9258 12.6279 10.7773 12.7444 10.6607C12.8609 10.5442 13.0094 10.4648 13.1711 10.4327C13.3327 10.4005 13.5003 10.417 13.6526 10.4801C13.8048 10.5432 13.935 10.65 14.0266 10.787C14.1181 10.9241 14.167 11.0852 14.167 11.25C14.167 11.471 14.0792 11.683 13.9229 11.8393C13.7666 11.9955 13.5547 12.0833 13.3337 12.0833Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const DollarIcon = ({
  className = "",
  fillColor = "#FA8C16",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 9.16406H10.8333V5.83073H12.5C12.721 5.83073 12.933 5.91853 13.0893 6.07481C13.2455 6.23109 13.3333 6.44305 13.3333 6.66406C13.3333 6.88508 13.4211 7.09704 13.5774 7.25332C13.7337 7.4096 13.9457 7.4974 14.1667 7.4974C14.3877 7.4974 14.5996 7.4096 14.7559 7.25332C14.9122 7.09704 15 6.88508 15 6.66406C15 6.00102 14.7366 5.36514 14.2678 4.8963C13.7989 4.42745 13.163 4.16406 12.5 4.16406H10.8333V2.4974C10.8333 2.27638 10.7455 2.06442 10.5893 1.90814C10.433 1.75186 10.221 1.66406 10 1.66406C9.77899 1.66406 9.56702 1.75186 9.41074 1.90814C9.25446 2.06442 9.16667 2.27638 9.16667 2.4974V4.16406H8.33333C7.44928 4.16406 6.60143 4.51525 5.97631 5.14037C5.35119 5.76549 5 6.61334 5 7.4974C5 8.38145 5.35119 9.2293 5.97631 9.85442C6.60143 10.4795 7.44928 10.8307 8.33333 10.8307H9.16667V14.1641H7.5C7.27899 14.1641 7.06702 14.0763 6.91074 13.92C6.75446 13.7637 6.66667 13.5517 6.66667 13.3307C6.66667 13.1097 6.57887 12.8978 6.42259 12.7415C6.26631 12.5852 6.05435 12.4974 5.83333 12.4974C5.61232 12.4974 5.40036 12.5852 5.24408 12.7415C5.0878 12.8978 5 13.1097 5 13.3307C5 13.9938 5.26339 14.6297 5.73223 15.0985C6.20107 15.5673 6.83696 15.8307 7.5 15.8307H9.16667V17.4974C9.16667 17.7184 9.25446 17.9304 9.41074 18.0867C9.56702 18.2429 9.77899 18.3307 10 18.3307C10.221 18.3307 10.433 18.2429 10.5893 18.0867C10.7455 17.9304 10.8333 17.7184 10.8333 17.4974V15.8307H11.6667C12.5507 15.8307 13.3986 15.4795 14.0237 14.8544C14.6488 14.2293 15 13.3815 15 12.4974C15 11.6133 14.6488 10.7655 14.0237 10.1404C13.3986 9.51525 12.5507 9.16406 11.6667 9.16406ZM9.16667 9.16406H8.33333C7.89131 9.16406 7.46738 8.98847 7.15482 8.67591C6.84226 8.36335 6.66667 7.93942 6.66667 7.4974C6.66667 7.05537 6.84226 6.63145 7.15482 6.31888C7.46738 6.00632 7.89131 5.83073 8.33333 5.83073H9.16667V9.16406ZM11.6667 14.1641H10.8333V10.8307H11.6667C12.1087 10.8307 12.5326 11.0063 12.8452 11.3189C13.1577 11.6314 13.3333 12.0554 13.3333 12.4974C13.3333 12.9394 13.1577 13.3633 12.8452 13.6759C12.5326 13.9885 12.1087 14.1641 11.6667 14.1641Z"
        fill={fillColor}
      />
    </svg>
  );
};
